import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ChangeDetectorService {
  eventTrigger: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  eventTriggerObservable: Observable<boolean>;
  constructor() {
    this.eventTriggerObservable = this.eventTrigger.asObservable();
  }
  InitiateDetection() {
    this.eventTrigger.next(true);
    
  }
}